(() => {
  function init(root = document) {
    root.querySelectorAll('[data-vv-carousel]').forEach(section => {
      if (section.dataset.vvReady) return;
      section.dataset.vvReady = 'true';
      const track = section.querySelector('[data-vv-track]');
      const prev = section.querySelector('[data-vv-prev]');
      const next = section.querySelector('[data-vv-next]');
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max < 4;
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft >= max - 4;
      };
      const move = direction => {
        const first = track.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}
      });
      const observer = new ResizeObserver(sync);
      observer.observe(track);
      section._vvObserver = observer;
      sync();
    });

    root.querySelectorAll('[data-vv-gallery]').forEach(gallery => {
      if (gallery.dataset.vvReady) return;
      gallery.dataset.vvReady = 'true';
      const buttons = [...gallery.querySelectorAll('[data-vv-thumb]')];
      const select = button => {
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        gallery.querySelectorAll('[data-vv-slide]').forEach(slide => {slide.hidden = slide.dataset.vvSlide !== button.dataset.vvThumb;});
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowDown','ArrowRight'].includes(event.key) ? 1 : -1;
          const target = buttons[(index + direction + buttons.length) % buttons.length];
          target.focus();select(target);
        });
      });
    });
    root.querySelectorAll('[data-optical-product]').forEach(product => {
      if (product.dataset.vrFrameReady) return;
      product.dataset.vrFrameReady = 'true';
      const selector = product.querySelector('[data-frame-variant]');
      const form = product.querySelector('[data-vr-frame-only-form]');
      const variantInput = form?.querySelector('[data-vr-cart-variant]');
      const button = form?.querySelector('button[type="submit"]');
      const price = product.querySelector('[data-frame-price]');
      const notice = product.querySelector('[data-vr-photo-note]');
      const gallery = product.querySelector('[data-vv-gallery]');
      const money = cents => new Intl.NumberFormat(product.dataset.locale || 'en-GB', {
        style:'currency', currency:product.dataset.currency || 'GBP'
      }).format(cents / 100);
      const sync = (updateGallery = true) => {
        const option = selector?.selectedOptions[0];
        const variantId = option?.value || product.querySelector('[data-default-variant]')?.value;
        if (variantInput && variantId) variantInput.value = variantId;
        const cents = option ? Number(option.dataset.price) : Number(price?.dataset.cents);
        if (Number.isSafeInteger(cents) && cents >= 0) {
          if (price) {price.textContent = money(cents);price.dataset.cents = String(cents);}
          if (button) button.textContent = 'Add frame only to bag — ' + money(cents);
        }
        if (button) button.disabled = Boolean(option?.disabled) || !variantId;
        if (!option) return;
        const imageIndex = Number(option.dataset.imageIndex ?? '-1');
        const selectedHasPhoto = Number.isInteger(imageIndex) && imageIndex >= 0;
        const galleryButton = gallery?.querySelector('[data-vv-thumb="' + (selectedHasPhoto ? imageIndex : 0) + '"]');
        if (galleryButton && updateGallery) galleryButton.click();
        if (notice) {
          const otherColour = variantId !== product.dataset.photographedVariant;
          notice.hidden = !otherColour || selectedHasPhoto;
          const colour = notice.querySelector('[data-vr-selected-colour]');
          if (colour) colour.textContent = option.dataset.colour || option.textContent.trim();
        }
      };
      selector?.addEventListener('change', sync);
      form?.addEventListener('submit', event => {
        sync(false);
        if (!variantInput?.value || button?.disabled) {
          event.preventDefault();
          const feedback = product.querySelector('[data-pdp-feedback]');
          if (feedback) feedback.textContent = 'Choose an available frame colour before adding it to your bag.';
        }
      });
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-vv-carousel]').forEach(section => section._vvObserver?.disconnect()));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-vv-search][open]').forEach(search => {search.open = false;search.querySelector('summary').focus();});
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-vv-search][open]').forEach(search => {if (!search.contains(event.target)) search.open = false;});
  });
})();
